<template>
  <div>
    <!-- 项目名称返点 -->
    <van-dialog v-model="visible" title="项目名称返点" width="95%" style="height:80%;" class="editClue" :beforeClose="saveProjectName" :close-on-click-overlay="true" show-cancel-button>
      <van-button v-if="pointList.length == 0" style="margin: 10px auto 0;width: 80%" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点百分比</van-button>
      <van-cell style="color: #ee0a24;" :title="'注：请留意返点执行时间，如当前时间大于执行结束时间，返点会按 0% 计算'" />
      <van-collapse v-model="activeNamesP" style="height: 100%;overflow: scroll;">
        <van-collapse-item :title="index == 0?'返点':'阶梯返点'+(index)" :name="index" v-for="(item,index) in pointList" :key="index+'01'">
          <van-field v-model="item.percentage" label="返点百分比" placeholder="请输入返点百分比(若无填0)" type="number" :rules="[{ required: true }]" required >
            <template slot="right-icon">%</template>
          </van-field>
          <van-field v-model="item.useMoney" label="返点消耗" :placeholder="index == 0?'无需输入,阶梯返点请增加返点':'返点消耗'" type="number" maxlength="13" @blur="fixValue(item.useMoney,index)" :disabled="index == 0" :rules="index == 0?[]:[{ required: true }]" :required="index == 0?false:true">
            <template slot="label">返点消耗<span class="dayuxiaoyufu">{{pointList.length > 1?index == 0?'<':'≥':''}}</span></template>
            <template slot="right-icon">￥</template>
          </van-field>
          <van-field v-model="item.startTime" label="执行开始时间" placeholder="请选择执行开始时间" readonly clickable @click="showTimePicker('startTime',index)" />
          <van-field v-model="item.endTime" label="执行结束时间" placeholder="请选择执行结束时间" readonly clickable @click="showTimePicker('endTime',index)" />
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点</van-button>
            <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deletePoint(index)" v-if="index != 0">删除</van-button>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-dialog>

    <van-popup v-model="datetimePicker.showDate" position="bottom">
      <van-datetime-picker v-model="datetimePicker.date" type="datetime" :title="datetimePicker.title" :min-date="datetimePicker.minDate" @confirm="datetimePickerConfirm" @cancel="datetimePicker.showDate = false" />
    </van-popup>
  </div>
</template>

<script>
import newContract from '@/api/cont/newContract'
import payment from '@/api/cont/payment'
import { Toast, DatetimePicker } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    setPointVisible: Boolean,
    contId: [Number, String],
    contractId: [Number, String],
    execCustomerId: [Number, String],
    projectId: [Number, String],
    projectName: String
  },
  watch: {
    contractId: {
      immediate: true,
      handler(val, oldVal) {

      }
    },
    execCustomerId: {
      immediate: true,
      handler(val, oldVal) {

      }
    },
    setPointVisible: {
      immediate: true,
      handler(val, oldVal) {
        this.visible = val
      }
    },
    projectId: {
      immediate: true,
      async handler(val, oldVal) {
        if (val) {
          if (this.contractId) {
            await newContract.getRebateList({ contractId: this.contractId, projectId: val }).then(res => {
              this.pointList = res.rows
            })
            await newContract.getContract(this.contractId).then(res => {
              if (res.code === 200) {
                this.contInfo = res.data
              }
            })
          } else if (this.execCustomerId) {
            await payment.getRebateList({ execCustomerId: this.execCustomerId, projectId: val }).then(res => {
              this.pointList = res.rows
            })
            await newContract.getContract(this.contId).then(res => {
              if (res.code === 200) {
                this.contInfo = res.data
              }
            })
          }
        }
      }
    },
    projectName: {
      immediate: true,
      handler(val, oldVal) {

      }
    }
  },
  data() {
    return {
      activeNamesP: [0],
      datetimePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        // maxDate: new Date(2042, 11, 31),
        formKey: '',
        title: ''
      },
      pointList: [],

      visible: false,
      contInfo: {}
    }
  },
  mounted() {

  },
  methods: {
    addPoint() {
      const peo = {
        [this.contractId ? 'contractId' : 'execCustomerId']: this.contractId || this.execCustomerId,
        projectId: this.projectId,
        projectName: this.projectName,
        percentage: '',
        useMoney: '',
        startTime: this.contInfo.startTime ? this.contInfo.startTime + ' 00:00:00' : null,
        endTime: this.contInfo.endTime ? this.contInfo.endTime + ' 00:00:00' : null
      }
      this.pointList.push(peo)
      const res = this.activeNamesP.some(item => {
        return this.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.pointList.length - 1)
      }
    },
    // deletePoint
    async deletePoint(index) {
      if (this.pointList.length > 0) {
        this.pointList.splice(index, 1)
      }
    },
    async saveProjectName(type, done) {
      if (type === 'confirm') {
        try {
          if (this.pointList.length == 0) {
            Toast.fail('请输入返点')
            return
          }
          if (this.contractId) {
            newContract.addRebate(this.pointList, this.contractId).then(response => {
              if (response.code == 200) {
                Toast.success('项目名称返点操作成功')
                this.$emit('savePoint', this.pointList)
                this.visible = false
              } else {
                Toast.fail(response.msg)
              }
            })
          } else if (this.execCustomerId) {
            payment.addRebate(this.pointList, this.execCustomerId).then(response => {
              if (response.code == 200) {
                Toast.success('项目名称返点操作成功')
                this.$emit('savePoint', this.pointList)
                this.visible = false
              } else {
                Toast.fail(response.msg)
              }
            })
          }
          // done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.$emit('savePoint', '')
      }
    },
    fixValue(val, index) {
      if (index == 1) {
        this.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.pointList[index].useMoney = ''
      }
    },
    showTimePicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datetimePicker.formKey = type
      this.datetimePicker.showDate = true
    },
    datetimePickerConfirm(date) {
      if (this.index || this.index == 0) {
        this.pointList[this.index][this.datetimePicker.formKey] = this.formatDateTime(date)
      }
      this.datetimePicker.showDate = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 82%;
}
</style>
